export default __webpack_public_path__ + "static/media/calendar-alt.da823359.svg";